<script>
  import { onMount } from "svelte";

  import firebase from "firebase/app";
  import "firebase/database";

  import { firebaseConfig } from "./config.js";
  import Answer from "./Answer.svelte";
  import AnswerForm from "./AnswerForm.svelte";

  const ORDERING = {
    NEW: "NEW",
    POINT: "POINT",
  };

  let issueId;
  let issue;
  let answers;
  let visible = false;
  let ordering = ORDERING.POINT;

  firebase.initializeApp(firebaseConfig);

  const db = firebase.database();
  if (location.hostname === "localhost") {
    db.useEmulator("localhost", 9000);
  }

  onMount(() => {
    load();
  });

  async function load() {
    issueId = await getIssueId();
    issue = await getIssue(issueId);
    answers = await getAnswers(issueId);
    visible = true;
  }

  function getIssueId() {
    return new Promise((resolve, reject) => {
      db.ref('/widgets/1').once('value', (snapshot) => {
        const widget = snapshot.val();
        resolve(widget.issueId);
      });
    });
  }

  function getIssue(issueId) {
    return new Promise((resolve, reject) => {
      db.ref(`/issues/${issueId}/`).once('value', (snapshot) => {
        const issue = snapshot.val();
        resolve(issue);
      });
    });
  }
  function getAnswers(issueId) {
    return new Promise((resolve,reject) => {
      db.ref(`/answers/${issueId}/`).once('value', (snapshot) => {
        resolve(snapshot.val());
      });
    });
  }

  function orderAnswers(answers, ordering) {
    if (!answers) {
      return [];
    }
    const entries = Object.entries(answers).map((entry) => {
      entry[1].createdAt = new Date(entry[1].createdAt);
      return entry;
    });
    const key = (ordering === ORDERING.POINT) ? "point" : "createdAt";
    return Object.entries(answers).sort((a, b) => b[1][key] - a[1][key]);
  }
</script>
<div>
  <h1>大喜利</h1>
  <div>
    ※解答は一人一回でお願いします<br>
    ※IEでは動かないので Google Chromeなどお使いください <br>
    <ul class="flashes"></ul>
  </div>
  {#if visible}
  <h2>お題</h2>
  <div class="issue">
    {#if issue }
      <p>{ issue.body }</p>
    {/if}
  </div>
  <h2>回答</h2>
  <div class="ordering">
    <span
      role="button"
      class:active={ ordering === ORDERING.NEW }
      on:click={() => { ordering = ORDERING.NEW }}
    >日付順</span> |
    <span
      class:active={ ordering === ORDERING.POINT }
      role="button"
      on:click={() => { ordering = ORDERING.POINT }}
    >ポイント順</span>
  </div>
  <div>
  {#if answers }
    {#each orderAnswers(answers, ordering) as [answerId, answer]}
      <Answer {issueId} {answerId} {answer} on:vote={load}/>
    {/each}
  {/if}
  </div>
  <h2>回答する</h2>
  {#if issueId }
    <AnswerForm {issueId} on:save={load}/>
  {/if}
  {:else}
  <p>loading...</p>
  {/if}
</div>
<style>
  :global(body) {
    margin: 0 auto;
    padding: 0;
    width: 320px;
    color: #555;
    font-family: Lato, sans-serif;
    font-size: 16px;
  }
  h1, h2 {
    font-size: 1.2em;
    text-align: center;
    color: #FFF;
    background-color: #006600;
  }
  .issue {
    font-weight:bold;
    font-size:1.2em;
  }
  .ordering {
    text-align: right;
    font-weight:normal;
    font-size:0.9em;
  }
  .active {
    font-weight:bold;
    font-size:1em;
  }
</style>
